export const SET_SELECTED_PARAMETERS = "SET_SELECTED_PARAMETERS";
export const SET_GOOGLE_KEY_PARAMETER = "SET_GOOGLE_KEY_PARAMETER";